/**
 * 判断是否为IP地址
 * @param {string} hostname - 主机名
 * @returns {boolean} 是否为IP地址
 */
export function isIPAddress(hostname) {
  return /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(hostname);
}

/**
 * 获取当前域名
 * @returns {string} 当前域名
 */
export function getCurrentDomain() {
  return window.location.hostname;
}

/**
 * 获取cookie域名
 * @param {string} hostname - 主机名
 * @returns {string|undefined} cookie域名
 */
export function getCookieDomain(hostname = getCurrentDomain()) {
  if (process.env.NODE_ENV !== 'production') {
    return undefined;
  }
  return isIPAddress(hostname) ? undefined : '.' + hostname;
}

/**
 * 获取存储键前缀
 * @returns {string} 存储键前缀
 */
export function getStoragePrefix() {
  const domain = getCurrentDomain();
  return isIPAddress(domain) ? 'app' : domain.replace(/\./g, '_');
} 